"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  }
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

var AppTableHead = /*#__PURE__*/function (_React$Component) {
  _inherits(AppTableHead, _React$Component);

  function AppTableHead() {
    _classCallCheck(this, AppTableHead);

    return _possibleConstructorReturn(this, _getPrototypeOf(AppTableHead).apply(this, arguments));
  }

  _createClass(AppTableHead, [{
    key: "_sortBy",
    value: function _sortBy(name) {
      var order = _toConsumableArray(this.props.order);

      var existingOrder = order.find(function (x) {
        return x.field == name;
      });

      if (!existingOrder) {
        order.push({
          field: name,
          direction: 'asc'
        });
      } else {
        if (existingOrder.direction == 'desc') {
          order = order.filter(function (x) {
            return x.field != name;
          });
        } else {
          order[order.indexOf(existingOrder)].direction = existingOrder.direction == 'asc' ? 'desc' : 'asc';
        }
      }

      this.props.onOrder(order);
    }
  }, {
    key: "render",
    value: function render() {
      var _this = this;

      var columns = this.props.columns;
      var columnElements = [];
      columns.forEach(function (column) {
        var innerElement = column.label;

        if (column.sortable) {
          var chevron = null;

          var currentSort = _this.props.order.find(function (x) {
            return x.field == column.name;
          });

          if (currentSort) {
            chevron = _react["default"].createElement("i", {
              className: 'fa fa-' + (currentSort.direction == 'asc' ? 'chevron-up' : 'chevron-down')
            });
          }

          innerElement = _react["default"].createElement("a", {
            href: "javascript:void(0)",
            className: "app-table-sort-link",
            onClick: function onClick() {
              return _this._sortBy(column.name);
            }
          }, column.label, " ", chevron);
        }

        columnElements.push(_react["default"].createElement("td", {
          key: 'td' + column.name,
          align: column.type == 'actions' ? 'right' : 'left'
        }, innerElement));
      });
      return _react["default"].createElement("tr", {
        className: "tr-dark-bg"
      }, columnElements);
    }
  }]);

  return AppTableHead;
}(_react["default"].Component);

exports["default"] = AppTableHead;
AppTableHead.defaultProps = {
  onOrder: function onOrder(order) {
    return console.log('changing order to ', order);
  }
};